import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { ProgressBarService } from '../shared/progress-bar.service';

@Component({
  standalone: false,
  selector: 'app-thanks-card',
  templateUrl: './thanks-card.component.html',
  styleUrls: ['./thanks-card.component.css','../shared/css/common.css']
})
export class ThanksCardComponent implements OnInit {

  finalForm = this.finalFormBuilder.group({});
  finalFormData: any;
  formdata: any;
  payorkey: number;
  confirmationmsg = "";
  isMember: boolean = false;
  primaryColor?: string = "";
  
  constructor(
    private finalFormBuilder: FormBuilder,
    private router: Router,
    private finalService: ReferalFormService,
    private vendorService: VendorService,
    private referalService: ReferalFormService,
    private progressBarService: ProgressBarService
  ) {
    const rawFormdata = this.vendorService.getSessionData();;
    if (rawFormdata) {
      try {
        this.formdata = rawFormdata;
      } catch (e) {
        console.error('Failed to parse activeformdata from sessionStorage:', e);
        this.formdata = this.referalService.getFormLoadJSON();
      }
    } else {
      this.formdata = this.referalService.getFormLoadJSON();
    }

    this.finalFormData = this.formdata.finalDetails;
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
  }


  ngOnInit(): void {
    this.loadDate();
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
    
    this.progressBarService.sendData(true);
  }

    loadDate() {
      this.vendorService.getLeadConfirmation(this.payorkey, this.vendorService.getStoredInstanceNumber()).subscribe((result) => {
        this.confirmationmsg = result.Message;

        let activeFormDataStr = sessionStorage.getItem('activeformdata');
        let formdata = this.referalService.getFormLoadJSON();
        sessionStorage.removeItem("activeformdata");

        if (activeFormDataStr) {
          try {
            const parsed = JSON.parse(activeFormDataStr);
            formdata.userDetails = parsed.userDetails;

            sessionStorage.setItem('activeformdata', JSON.stringify(formdata));
          } catch (e) {
            console.warn('Invalid activeformdata in sessionStorage:', e);
          }
        }
        
        window.sessionStorage.removeItem("UserDetailsFormValid");
        window.sessionStorage.removeItem("ReferralFormValid");
        window.sessionStorage.removeItem("InvolvedPartyFormValid");
        window.sessionStorage.removeItem("AdditionalInvolvedPartyFormValid");
        window.sessionStorage.removeItem("QuestionsFormValid");
        window.localStorage.removeItem("SendEmailReferral");
      });
    }




  finalDetailsSubmit() {
  const data = localStorage.getItem('activeformdata');
  if (data) {
    const form = JSON.parse(data);
    const org = form?.userDetails?.controls?.find((x: any) => x.name === 'orgName');
    if (org) org.value = '';
    localStorage.setItem('activeformdata', JSON.stringify(form));
  }
  sessionStorage.setItem('returningFromThanksCard', 'true');
  localStorage.setItem('isNewReferral', 'true');
  const securityCode = sessionStorage.getItem("securityCode") ?? "";
  this.router.navigateByUrl('/', { skipLocationChange: true })
    .then(() => {
      this.router.navigateByUrl("/" + securityCode);
  
      setTimeout(() => {
        this.progressBarService.sendData(true);
      });
  });
    
  }
}
